/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { comparisonTableHeroV2Messages } from '../messages/comparison-table-hero-v2';
import { SpeedMessages } from '../messages/speed';
export const ComparisonTableHeroV2Translations = merge(undefined, commonMessages, SpeedMessages, comparisonTableHeroV2Messages);
